var path = 'app/scripts/modules/core/src/pipeline/config/triggers/jenkins/selectorTemplate.html';
var html = "<jenkins-trigger-options command=\"vm.command\"></jenkins-trigger-options>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/triggers/jenkins/selectorTemplate.html
// module id = 1038
// module chunks = 0